<template>
  <div>
    <header-bar>著作権管理サービス</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3
          class="page-block__title">
          作品一覧
        </h3>
      </div>
      <div class="page-block__inner">
        <div class="c-btn-wrap">
          <div class="info">
            <p v-if="!isEnabledCopyrightOperation()">
              <b>Coming soon</b><br>
              本サービスのご利用は、4月中旬を予定しています。
              今しばらくお待ちください。
            </p>
            <div
              v-else
              class="info--desc">
              <p>次回の著作権申請の締切は<b>{{ nextDeadline }}月10日</b>です。余裕をもって申請を完了させてください。</p>
              <p>なお、登録完了までに数ヶ月かかる場合があります。</p>
              <p>不備・確認などがあった場合は別途ご連絡を差し上げます。</p>
            </div>
          </div>
          <router-link
            v-if="companyTier !== companyTierC"
            :class="{ 'c-btn--off' : !isEnabledCopyrightOperation() }"
            :to="{name:'copyright-create'}"
            :disabled="!isEnabledCopyrightOperation()"
            class="c-btn c-btn--narrow c-btn--right">
            配信していない楽曲を申請する
          </router-link>
        </div>
        <div class="tabs">
          <button
            v-if="companyTier !== companyTierC"
            :class="currentStatus !== tabs[0] ? 'c-btn':
              'c-btn active'"
            :disabled="currentStatus === tabs[0]"
            @click="onTabClicked(tabs[0])">
            申請可能な作品（{{ totalPages.CMAP_RELEASE_STATUS_PUBLISHED }}件）
          </button>
          <button
            v-if="hasStatusProcessingCopyrights"
            :class="currentStatus !== tabs[1] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[1]"
            @click="onTabClicked(tabs[1])">
            管理中 （{{ totalPages.CMAP_COPYRIGHT_STATUS_PROCESSING }}件）
          </button>
          <button
            v-if="hasStatusInProgressCopyrights
              && companyTier !== companyTierC"
            :class="currentStatus !== tabs[2] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[2]"
            @click="onTabClicked(tabs[2])">
            作成中 （{{ totalPages.CMAP_COPYRIGHT_STATUS_IN_PROGRESS }}件）
          </button>
          <button
            v-if="hasStatusInPendingCopyrights
              && companyTier !== companyTierC"
            :class="currentStatus !== tabs[4] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[4]"
            @click="onTabClicked(tabs[4])">
            承認待ち （{{ totalPages.CMAP_COPYRIGHT_STATUS_IN_PENDING }}件）
          </button>
          <button
            v-if="hasStatusInReviewCopyrights
              && companyTier !== companyTierC"
            :class="currentStatus !== tabs[3] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[3]"
            @click="onTabClicked(tabs[3])">
            審査中 （{{ totalPages.CMAP_COPYRIGHT_STATUS_IN_REVIEW }}件）
          </button>
          <button
            v-if="hasStatusInReviewCopyrights
              && companyTier !== companyTierC"
            :class="currentStatus !== tabs[6] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[6]"
            @click="onTabClicked(tabs[6])">
            申請済み（{{ totalPages.CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS }}件）
          </button>
          <button
            v-if="hasStatusInRejectedCopyrights
              && companyTier !== companyTierC"
            :class="currentStatus !== tabs[5] ? 'c-btn'
              :'c-btn active'"
            :disabled="currentStatus === tabs[5]"
            @click="onTabClicked(tabs[5])">
            却下 （{{ totalPages.CMAP_COPYRIGHT_STATUS_REJECTED }}件）
          </button>
        </div>
        <table
          v-if="pagination.total > 0"
          class="copyright-list__table">
          <thead class="copyright-list__thead">
            <tr>
              <th class="copyright-list__cell">リリースタイトル</th>
              <th class="copyright-list__cell">作詞者公表名</th>
              <th class="copyright-list__cell">作曲者公表名</th>
              <th
                v-if="currentStatus === 3"
                class="copyright-list__cell">
                作品コード
              </th>
              <th class="copyright-list__cell">アーティスト名</th>
              <th
                v-if="!isRejectedStatus"
                class="copyright-list__cell"></th>
            </tr>
          </thead>
          <tbody
            class="copyright-list__tbody">
            <tr
              v-for="(item, index) in pagination.data"
              :key="'copyrights' + index">
              <td>{{ item.title_ja }}</td>
              <td>{{ item.lyricist }}</td>
              <td>{{ item.composer }}</td>
              <td v-if="currentStatus === 3">{{ item.work_code }}</td>
              <td>{{ item.artist_name }}</td>
              <td v-if="!isRejectedStatus">
                <button
                  class="c-btn mw-0 table-btn"
                  @click.prevent="onActionClicked(item)">
                  {{ getStatusText(currentStatus, item.split_status) }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-else
          class="artist-list">
          <p class="artist-not-exist">
            申請可能な作品がありません。
          </p>
        </div>
        <pagination
          :pagination="pagination"
          @on-pagination-clicked="onPaginationClicked($event)">
        </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HeaderBar from '../HeaderBar'
import Pagination from '../../../components/Pagination'
import {
  CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS,
  CMAP_COPYRIGHT_STATUS_IN_PENDING,
  CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
  CMAP_COPYRIGHT_STATUS_IN_REVIEW,
  CMAP_COPYRIGHT_STATUS_PROCESSING,
  CMAP_COPYRIGHT_STATUS_REJECTED,
  CMAP_RELEASE_STATUS_DSP_IN_REVIEW, CMAP_RELEASE_STATUS_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
} from '../../../consts/status'
import { COMPOSER, LYRICIST } from './consts'

export default {
  name: 'CopyrightIndex',
  components: {
    HeaderBar,
    Pagination,
  },
  data() {
    return {
      tabs: [
        CMAP_RELEASE_STATUS_PUBLISHED || CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
        CMAP_COPYRIGHT_STATUS_PROCESSING,
        CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
        CMAP_COPYRIGHT_STATUS_IN_REVIEW,
        CMAP_COPYRIGHT_STATUS_IN_PENDING,
        CMAP_COPYRIGHT_STATUS_REJECTED,
        CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS,
      ],
      currentStatus: CMAP_RELEASE_STATUS_PUBLISHED,
      pagination: {
        data: [],
      },
      page: 0,
      loading: false,
      targetId: '',
      totalPages: {
        CMAP_RELEASE_STATUS_PUBLISHED: 0,
        CMAP_COPYRIGHT_STATUS_PROCESSING: 0,
        CMAP_COPYRIGHT_STATUS_IN_PROGRESS: 0,
        CMAP_COPYRIGHT_STATUS_IN_REVIEW: 0,
        CMAP_COPYRIGHT_STATUS_IN_PENDING: 0,
        CMAP_COPYRIGHT_STATUS_REJECTED: 0,
        CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS: 0,
      },
      companyTierC: 'C',
      companyTier: '',
    }
  },
  computed: {
    hasStatusProcessingCopyrights() {
      return this.totalPages.CMAP_COPYRIGHT_STATUS_PROCESSING > 0
    },
    hasStatusInProgressCopyrights() {
      return this.totalPages.CMAP_COPYRIGHT_STATUS_IN_PROGRESS > 0
    },
    hasStatusInReviewCopyrights() {
      return this.totalPages.CMAP_COPYRIGHT_STATUS_IN_REVIEW > 0
    },
    hasStatusInPendingCopyrights() {
      return this.totalPages.CMAP_COPYRIGHT_STATUS_IN_PENDING > 0
    },
    hasStatusInRejectedCopyrights() {
      return this.totalPages.CMAP_COPYRIGHT_STATUS_REJECTED > 0
    },
    /**
     * 届出申請の締め切りは、各四半期（3月, 6月, 9月, 12月）の10日です
     */
    nextDeadline() {
      const month = moment().month() + 1
      const day = moment().date()
      let curMonth = 1
      if (month >= 1 && month <= 3) {
        curMonth = month === 3 && day > 10 ? 6 : 3
      } else if (month >= 4 && month <= 6) {
        curMonth = month === 6 && day > 10 ? 9 : 6
      } else if (month >= 7 && month <= 9) {
        curMonth = month === 9 && day > 10 ? 12 : 9
      } else if (month >= 9 && month <= 12) {
        curMonth = month === 12 && day > 10 ? 3 : 12
      }
      return curMonth
    },
    isRejectedStatus() {
      return this.currentStatus === CMAP_COPYRIGHT_STATUS_REJECTED
    },
  },
  mounted() {
    this.companyTier = this.$store.state.auth.company.tier
    window.sessionStorage.setItem('copyright-split', JSON.stringify({}))
    this.currentStatus = this.companyTier !== this.companyTierC
      ? CMAP_RELEASE_STATUS_PUBLISHED : CMAP_COPYRIGHT_STATUS_PROCESSING
    this.fetchItems()
    this.getTotals()
  },
  methods: {
    async fetchItems(page = 0) {
      this.loading = true
      const queryParams = {
        count: 10,
        page,
      }
      if (this.isDeliveredTrack()) {
        queryParams.status = [
          CMAP_RELEASE_STATUS_PUBLISHED,
          CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
          CMAP_RELEASE_STATUS_IN_REVIEW,
        ]
      } else if (this.currentStatus === CMAP_COPYRIGHT_STATUS_IN_REVIEW) {
        // show jasrac under review copyright data in under review status list
        queryParams.status = [
          CMAP_COPYRIGHT_STATUS_IN_REVIEW,
          CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS,
        ]
      } else {
        queryParams.status = this.currentStatus
      }
      const { data } = await window.axios.get(
        this.currentStatus === CMAP_RELEASE_STATUS_PUBLISHED
        || this.currentStatus === CMAP_RELEASE_STATUS_DSP_IN_REVIEW
          ? '/api/client/tracks'
          : '/api/client/copyrights',
        { params: queryParams },
      )
      this.pagination = data
      if (this.isDeliveredTrack()) {
        this.pagination.data = this.pagination.data.map(obj => {
          const newObj = { ...obj }
          newObj.lyricist = this.getTrackLyricistName(newObj)
          newObj.composer = this.getTrackComposerName(newObj)
          newObj.artist_name = newObj.name_ja
          return newObj
        })
      } else {
        this.pagination.data = this.pagination.data.map(obj => {
          const newObj = { ...obj }
          newObj.lyricist = this.getCopyrightLyricistName(newObj)
          newObj.composer = this.getCopyrightComposerName(newObj)
          newObj.artist_name = this.getCopyrightArtistName(newObj)
          return newObj
        })
      }
      this.loading = false
    },
    async getTotals() {
      const { data } = await window.axios.get('/api/client/copyrights/get/getTotalCopyrightCount')
      this.totalPages.CMAP_COPYRIGHT_STATUS_PROCESSING = data.statusProcessingCount
      this.totalPages.CMAP_COPYRIGHT_STATUS_IN_PENDING = data.statusPendingCount
      this.totalPages.CMAP_COPYRIGHT_STATUS_IN_PROGRESS = data.statusInProgressCount
      this.totalPages.CMAP_COPYRIGHT_STATUS_IN_REVIEW = data.statusInReviewCount
      this.totalPages.CMAP_RELEASE_STATUS_PUBLISHED = data.statusPublishedCount
      this.totalPages.CMAP_COPYRIGHT_STATUS_REJECTED = data.statusRejectedCount
      // eslint-disable-next-line max-len
      this.totalPages.CMAP_COPYRIGHT_JASCRAC_REVIEW_IN_PROGRESS = data.statusJasracReviewInProgressCount
    },
    onTabClicked(status) {
      this.currentStatus = status
      this.fetchItems(0)
    },
    onPaginationClicked(page) {
      this.page = page
      this.fetchItems(this.page)
    },
    async onEditClicked(id) {
      let split = {}
      switch (this.currentStatus) {
        case this.tabs[0]:
          this.$router.push({ name: 'get-track', params: { id } })
          break
        case this.tabs[1]:
          this.$router.push({ name: 'copyright-confirm', params: { id } })
          break
        case this.tabs[2]:
          this.$router.push({ name: 'copyright-edit', params: { id } })
          break
        case this.tabs[3]:
        case this.tabs[6]:
          this.$router.push({ name: 'copyright-confirm', params: { id } })
          break
        case this.tabs[4]:
          split = JSON.parse(window.sessionStorage.getItem('copyright-split'))
          split.copyrightId = id
          window.sessionStorage.setItem('copyright-split', JSON.stringify(split))
          this.$router.push({ name: 'copyright-splits-detail', params: { id } })
          break
        default:
      }
    },
    isDeliveredTrack() {
      return (this.currentStatus === CMAP_RELEASE_STATUS_PUBLISHED
        || this.currentStatus === CMAP_RELEASE_STATUS_DSP_IN_REVIEW)
    },
    getCopyrightArtistName(item) {
      return item.artists.main_artists[0].name_ja
    },
    getTrackLyricistName(item) {
      const metaArtist = JSON.parse(item.meta_artists)
      const copyrightArtist = metaArtist.copyright_artists
      const lyricistArr = copyrightArtist.map((author) => {
        if (author.roles.includes(LYRICIST)) {
          return author.name_ja
        }
        return ''
      }).filter((value) => value !== '')
      // multiple lyricist are displayed in comma separated
      if (lyricistArr.length > 1) {
        return lyricistArr.join(', ')
      }
      return lyricistArr[0] || ''
    },
    getTrackComposerName(item) {
      const metaArtist = JSON.parse(item.meta_artists)
      const copyrightArtist = metaArtist.copyright_artists
      const composerArr = copyrightArtist.map((author) => {
        if (author.roles.includes(COMPOSER)) {
          return author.name_ja
        }
        return ''
      }).filter((value) => value !== '')
      // multiple composer are displayed in comma separated
      if (composerArr.length > 1) {
        return composerArr.join(', ')
      }
      return composerArr[0] || ''
    },
    getCopyrightLyricistName(item) {
      if (!item.authors) return ''
      const lyricistArr = item.authors.map((author) => {
        let roles = author.pivot.author_roles
        roles = roles.map(role => {
          if (role.checked) {
            return role.value
          }
          return ''
        })
        if (roles.includes(LYRICIST)) {
          return author.name_ja
        }
        return ''
      }).filter((value) => value !== '')
      // multiple lyricist are displayed in comma separated
      if (lyricistArr.length > 1) {
        return lyricistArr.join(', ')
      }
      return lyricistArr[0] || ''
    },
    getCopyrightComposerName(item) {
      if (!item.authors) return ''
      const composerArr = item.authors.map((author) => {
        let roles = author.pivot.author_roles
        roles = roles.map(role => {
          if (role.checked) {
            return role.value
          }
          return ''
        })
        if (roles.includes(COMPOSER)) {
          return author.name_ja
        }
        return ''
      }).filter((value) => value !== '')
      // multiple composer are displayed in comma separated
      if (composerArr.length > 1) {
        return composerArr.join(', ')
      }
      return composerArr[0] || ''
    },
    /**
     * Gets the text based on the provided status.
     *
     * @param {int} status - The status to determine the text.
     * @param {int} splitStatus - The status of copyright splits.
     * @returns {string} - The corresponding text.
     */
    getStatusText(status, splitStatus) {
      let btnText = '届出申請'

      switch (status) {
        case CMAP_RELEASE_STATUS_PUBLISHED:
        case CMAP_RELEASE_STATUS_DSP_IN_REVIEW:
          btnText = '届出申請'
          break
        case CMAP_COPYRIGHT_STATUS_PROCESSING:
        case CMAP_COPYRIGHT_STATUS_IN_REVIEW:
        case CMAP_COPYRIGHT_STATUS_IN_PENDING:
          btnText = '詳細'
          break
        case CMAP_COPYRIGHT_STATUS_IN_PROGRESS:
          btnText = splitStatus && splitStatus[0] && splitStatus[0].status === 1 ? '詳細' : '申請の再開'
          break
        default:
          break
      }

      return btnText
    },
    /**
     * Handles the click event for a specific action on a row.
     * @param {int} rowId - The id of the row that triggered the action.
     * @param {int} status - The current status associated with the row.
     */
    onActionClicked(item) {
      const rowId = item.id
      this.targetId = rowId
      this.onEditClicked(rowId)
    },
    isEnabledCopyrightOperation() {
      return this.$store.state.auth.enable_copyright_operation
    },
  },
}
</script>

<style scoped>
.c-btn {
  padding: 10px 20px;
}
.info {
  display: flex;
}
.tabs {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 15px;
  margin: 0 auto;
  padding: 30px 0 10px 0;
}
.tabs button {
  min-width: calc(18% - 10px) !important;
  background-color: #e6e6e6;
  color: #4b4b4b;
}
.active {
  background-color: #34458D !important;
  color: #fff !important;
}

.table-btn {
  min-width: 0;
}

.info--desc {
  flex-direction: column;
  text-align: left;
}

</style>
